import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { KeycloakService } from "../../utility/keycloak.service";

@Injectable({ providedIn: "root" })
export class AuthGuard implements CanActivate {
  constructor(
    private readonly keycloakService: KeycloakService,
    private readonly router: Router,
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Promise<boolean> {
    await this.keycloakService.isInitialized();

    const token = await this.keycloakService.getValidToken();

    if (token) {
      return true;
    }

    this.keycloakService.saveReturnUrl(state.url);

    this.router.navigateByUrl("/auth/initial");

    return false;
  }
}